module.exports = __webpack_public_path__ + "img/hr-V-R-5-unload-connect-shadow.f1a2ae9c.png";